import { render, staticRenderFns } from "./WeekendPhone.vue?vue&type=template&id=3fd0fde1&"
import script from "./WeekendPhone.vue?vue&type=script&lang=js&"
export * from "./WeekendPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports